module.exports = __webpack_public_path__ + "static/media/Mercatorum.6f42e9ea.png";